import React from 'react';
import { motion } from 'framer-motion';

const Contact = () => {
  const contactInfo = [
    {
      title: 'Email Support',
      value: 'support@chillgaming.sg',
      icon: '📧',
      description: 'Reply within 24 hours'
    },
    {
      title: 'WhatsApp Support',
      value: '+60 11-1424 0380',
      icon: '💬',
      description: '(customer service)'
    },
    {
      title: 'Meetup Location',
      value: 'Available at Sengkang & Orchard locations',
      icon: '📍',
      description: 'Self-collect available'
    }
  ];

  const faqItems = [
    {
      question: 'Is this product compatible with my console?',
      answer: 'Please check the compatibility details on the product page. Most accessories support Switch / Switch Lite / OLED / PC.'
    },
    {
      question: 'How long does shipping take?',
      answer: 'In-stock items are usually shipped within 1–3 business days. Delivery time is about 7–15 days depending on your location.'
    },
    {
      question: 'Does the product come with a warranty?',
      answer: 'Some items include a limited 3–5 day warranty. Please refer to the product description for details.'
    },
    {
      question: 'Do you accept returns or exchanges?',
      answer: 'If your item arrives damaged or defective, please contact us within 24 hours of receipt for assistance.'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-blue-900 to-purple-900 pb-20">
      <div className="container mx-auto px-4 py-8">
        <motion.h1 
          className="text-3xl font-bold text-white mb-8"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          Contact Us
        </motion.h1>

        <div className="max-w-4xl mx-auto space-y-6">
          {/* Contact Information */}
          <motion.div 
            className="bg-gray-800 rounded-lg p-6"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
          >
            <h2 className="text-2xl font-bold text-white mb-6">Get in Touch</h2>
            
            <div className="space-y-4">
              {contactInfo.map((info, index) => (
                <motion.div
                  key={info.title}
                  className="flex items-start space-x-4"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.3 + index * 0.1 }}
                >
                  <div className="text-2xl">{info.icon}</div>
                  <div>
                    <h3 className="text-white font-semibold">{info.title}</h3>
                    <p className="text-blue-400 font-medium">{info.value}</p>
                    <p className="text-gray-400 text-sm">{info.description}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>

          {/* FAQ Section */}
          <motion.div 
            className="bg-gray-800 rounded-lg p-6"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
          >
            <h2 className="text-2xl font-bold text-white mb-6">Frequently Asked Questions</h2>
            
            <div className="space-y-4">
              {faqItems.map((faq, index) => (
                <motion.div
                  key={index}
                  className="border-b border-gray-700 pb-4 last:border-b-0"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.4 + index * 0.1 }}
                >
                  <h3 className="text-white font-semibold mb-2">{faq.question}</h3>
                  <p className="text-gray-400 text-sm">{faq.answer}</p>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default Contact;